const TRUSTED_DEVICE_PREFIX = 'lexsavvy_trusted_device_';
const TRUST_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function getKey(userId: string): string {
  return `${TRUSTED_DEVICE_PREFIX}${userId}`;
}

export function isDeviceTrusted(userId: string): boolean {
  try {
    const raw = localStorage.getItem(getKey(userId));
    if (!raw) return false;
    const expiresAt = parseInt(raw, 10);
    if (isNaN(expiresAt)) return false;
    return Date.now() < expiresAt;
  } catch {
    return false;
  }
}

export function trustDevice(userId: string): void {
  try {
    localStorage.setItem(getKey(userId), String(Date.now() + TRUST_DURATION_MS));
  } catch {
    // localStorage may be unavailable
  }
}

export function clearDeviceTrust(userId: string): void {
  try {
    localStorage.removeItem(getKey(userId));
  } catch {
    // ignore
  }
}
